import React from 'react';
import { useForm } from 'react-hook-form';
import { IGenericForm } from './GenericForm.definition';

const Form = ({ children, onSubmit, defaultValues }: IGenericForm) => {
	const { register, handleSubmit, control } = useForm({ mode: 'onChange', defaultValues });

	return (

		<form onSubmit={ handleSubmit(onSubmit) }>{ children({ control, register }) }</form>


	);
};

export default Form;